import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-96b6ec3c")

_pushScopeId("data-v-96b6ec3c")
const _hoisted_1 = { class: "image-style-panel" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 替换音频")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ElementOutline = _resolveComponent("ElementOutline")
  const _component_Divider = _resolveComponent("Divider")
  const _component_IconTransform = _resolveComponent("IconTransform")
  const _component_Button = _resolveComponent("Button")
  const _component_FileAudio = _resolveComponent("FileAudio")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ElementOutline),
    _createVNode(_component_Divider),
    _createVNode(_component_FileAudio, {
      onChange: _cache[1] || (_cache[1] = files => _ctx.replaceAudio(files))
    }, {
      default: _withId(() => [
        _createVNode(_component_Button, { class: "full-width-btn" }, {
          default: _withId(() => [
            _createVNode(_component_IconTransform, { class: "btn-icon" }),
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
})